@if (job) {
  <main>
    @if (!job.isFinalStatus) {
      <nav>
        <div class="text-right">
          <!--<button  label="Cancel" icon="fa fa-times" (click)="cancel()"
        class="p-button-sm p-button-outlined p-button-secondary mr-1"></button>-->
          <button label="Message" icon="fa fa-comment-o" (click)="isMessaging = true" class="p-button-sm p-button-outlined p-button-secondary"></button>
        </div>
      </nav>
    }
    <!--<div class="final-status" *ngIf="job.isFinalStatus">
  Job is at final status.
</div>-->
    <article>
      <section>
        <h3>
          <span title="elogbooks site #{{ job.site.id }}"> <i class="fa fa-fw fa-building"></i> {{ job.site.title }} </span>
        </h3>
        <div>
          <label>Summary</label>
          <p>{{ job.summary || 'no summary' }}</p>
        </div>
        <div>
          <label>Description</label>
          <p>{{ job.description || 'no description' }}</p>
        </div>
        <div>
          <label>Status</label>
          <p>
            <span title="{{ job.status }}">{{ job.statusDisplay }}</span>
          </p>
        </div>
        <div>
          <label>Created</label>
          <p title="{{ job.createdAt | amTimeAgo }}">{{ job.createdAt | date: 'dd-MM-yy HH:mm' }}</p>
        </div>
        @if (job.reminderAt) {
          <div>
            <label>Reminder</label>
            <p title="{{ job.reminderAt | amTimeAgo }}">{{ job.reminderAt | date: 'dd-MM-yy HH:mm' }}</p>
          </div>
        }
      </section>
      <section>
        <div class="mt-1">
          <p-timeline [value]="events" align="alternate" styleClass="customized-timeline">
            <ng-template pTemplate="marker" let-event>
              <span class="custom-marker p-shadow-2" [style.backgroundColor]="'#a0a0a0'">
                <i [ngClass]="event.icon"></i>
              </span>
            </ng-template>
            <ng-template pTemplate="content" let-event>
              <p-card>
                <p>{{ event.body }}</p>
                <p>{{ event.date | date: 'dd-MM-yy HH:mm' }}</p>
              </p-card>
            </ng-template>
          </p-timeline>
        </div>
      </section>
    </article>
  </main>
}

@if (job === null) {
  <main>
    <p>No job available, may still be open on another alarm if expected OR there may be a delay in receiving the job from elogbooks.</p>
  </main>
}

@if (isMessaging) {
  <div class="__modal0" (click)="m($event); isMessaging = null; (false)"></div>
}
@if (isMessaging) {
  <div class="_modal">
    <div>
      <div class="form-group">
        <label>Message</label>
        <textarea class="form-control" [(ngModel)]="note"></textarea>
      </div>
      <button label="OK" (click)="modalOK()"></button>
    </div>
  </div>
}
